var createReactClass = require('create-react-class');
import React from 'react';
import PropTypes from 'prop-types';

const ArticleCitations = createReactClass({
  propTypes: {
    htmlBody: PropTypes.shape({
      correct: PropTypes.arrayOf(PropTypes.string),
      incorrect: PropTypes.arrayOf(PropTypes.string),
      note: PropTypes.arrayOf(PropTypes.string)
    })
  },

  renderCorrectCitations: function () {
    const citationTypes = [
      "For references with a single author: (Name, Year)",
      "For references with two authors: (Name and Name, Year)",
      "For references with more than two authors: (Name et al., Year)",
      "For citing multiple references at a time in a sentence"
    ];

    return this.props.htmlBody.correct.map((citation, index) => (
      <div key={`correct-${index}`}>
        {citationTypes[index] && (
          <p><strong>{citationTypes[index]}</strong></p>
        )}
        <p>
          <i className="far fa-check-circle good" />
          &nbsp;Correct: {citation}
        </p>
      </div>
    ));
  },

  renderIncorrectCitations: function () {
    const incorrectTypes = [
      "For references with one author",
      "For references with two authors (incorrect format)",
      "For citing multiple references (incorrect format)"
    ];

    return this.props.htmlBody.incorrect.map((citation, index) => (
      <div key={`incorrect-${index}`}>
        {incorrectTypes[index] && (
          <p><strong>{incorrectTypes[index]}</strong></p>
        )}
        <p>
          <i className="fa fa-times-circle bad" />
          &nbsp;Incorrect: {citation}
        </p>
      </div>
    ));
  },

  renderNoteForCitations: function () {
    return this.props.htmlBody.note.map((note, index) => (
      <p key={`note-${index}`}>
        &nbsp;<strong>Note:</strong> {note}
      </p>
    ));
  },

  render: function () {
    return (
      <div>
        <h4 className="reg">How should I format my Article Citation?</h4>
        <p>Please note that all reference citations are punctuation and space sensitive, please follow the below-mentioned guidelines to cite your references:</p>

        <h5>Correct reference citation formats</h5>
        {this.renderCorrectCitations()}

        <h5>Incorrect reference citation formats</h5>
        {this.renderIncorrectCitations()}

        {this.renderNoteForCitations()}
      </div>
    );
  }
});

export default ArticleCitations;